export default "__VITE_ASSET__DAfF1CEr__"